import React from 'react';

import { Divider, Title, createStyles } from '@mantine/core';
import { TotalUncreditedReservations } from 'pages/private/owner/Dashboard/components/ReservationCard/TotalUncreditedReservations';

import { useDashboardStyles } from '../../styles';

const useStyles = createStyles(theme => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateRows: 'auto',
    gridTemplateAreas: '"totalUncreditedReservations none none none"',
    gap: theme.spacing.sm,
    padding: theme.spacing.md,
    [theme.fn.smallerThan('lg')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
      gridTemplateAreas: '"totalUncreditedReservations none none none"',
    },
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateAreas: '"totalUncreditedReservations none"',
    },
  },
  totalUncreditedReservations: {
    gridArea: 'totalUncreditedReservations',
  },
}));

const ReservationCard = (): JSX.Element => {
  const { classes: dashboard } = useDashboardStyles();
  const { classes } = useStyles();

  return (
    <div className={`${dashboard.reservations} ${dashboard.card}`}>
      <div className={dashboard.cardHeader}>
        <Title order={4}>Reservations</Title>
      </div>
      <Divider />
      <div className={classes.grid}>
        <TotalUncreditedReservations
          gridAreaClass={classes.totalUncreditedReservations}
          clickableCardClass={dashboard.clickableCard}
          labelClass={dashboard.label}
          valueClass={dashboard.value}
        />
      </div>
    </div>
  );
};

export default ReservationCard;
